import { type FacilityContact } from './FacilityContact'
import { type FacilityHours } from './FacilityHours'
import { type FacilityPerformance } from './FacilityPerformance'
import { type FacilityReport } from './FacilityReport'

export type Facility = {
  uuid: string
  companyName: string
  address: string
  zipcode: string
  city: string
  state: string
  country: string
  score?: number
  performance?: FacilityPerformance
  hours?: FacilityHours
  contact?: FacilityContact
  report?: FacilityReport
}

export const enum FacilityOperation {
  Pu = 'pu',
  Del = 'del',
}

export function createFacility(
  facility: Facility,
  performance?: FacilityPerformance,
  hours?: FacilityHours,
  contact?: FacilityContact,
  report?: FacilityReport
): Facility {
  return { ...facility, performance, hours, contact, report }
}
